import React from 'react';
import * as logger from '@happyreturns/jscommons';
import { loggedFetch } from './utility';

// calls analytics endpoint to log the visit
// status must be a one of the names in our analytics DB's tracking.status table
async function logVisit(carrier, tracking, status) {
  try {
    await loggedFetch(`/visit`, {
      method: 'POST',
      body: JSON.stringify({
        carrier: carrier,
        tracking: tracking,
        status: status,
      }),
    });
  } catch (err) {
    logger.Error('Error logging visit', err);
  }
}

// calls analytics endpoint to log a click n the marketing link
async function logMarketingLinkClick() {
  try {
    // this is async, but no need to wait for it to finish
    await loggedFetch(`/marketinglinkclick`, { method: 'POST' });
  } catch (err) {
    logger.Error('Error logging marketing link click', err);
  }
}

export { logVisit, logMarketingLinkClick };
